/** Server-side task list sort params for Platform Admin 任务控制中心. */

export type TaskControlViewMode = 'attention' | 'queue' | 'newest' | 'oldest' | 'custom'

export type TaskControlCustomSort = { field: string; dir: 'asc' | 'desc' }

/** VistoeraTASK-00211 — first visit defaults to 开始时间 DESC (newest started first). */
export const DEFAULT_TASK_CONTROL_CUSTOM_SORT: TaskControlCustomSort = {
  field: 'started_at',
  dir: 'desc',
}

export function resolveTaskControlListSort(
  viewMode: TaskControlViewMode,
  customSort: TaskControlCustomSort | null,
): { sort: string; sortDir: 'asc' | 'desc' } {
  const isQueueView = viewMode === 'queue'
  const sort = isQueueView
    ? 'queue'
    : viewMode === 'attention'
      ? 'attention'
      : viewMode === 'newest'
        ? 'created_at'
        : viewMode === 'oldest'
          ? 'created_at'
          : customSort?.field ?? 'created_at'
  const sortDir = isQueueView
    ? 'asc'
    : viewMode === 'attention'
      ? 'asc'
      : viewMode === 'newest'
        ? 'desc'
        : viewMode === 'oldest'
          ? 'asc'
          : customSort?.dir ?? 'desc'
  return { sort, sortDir }
}
